import _inherits from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { log, setGlobalLogger } from './log';
export var MetricLoggerUnit;

(function (MetricLoggerUnit) {
  MetricLoggerUnit["Seconds"] = "Seconds";
  MetricLoggerUnit["Microseconds"] = "Microseconds";
  MetricLoggerUnit["Milliseconds"] = "Milliseconds";
  MetricLoggerUnit["Bytes"] = "Bytes";
  MetricLoggerUnit["Kilobytes"] = "Kilobytes";
  MetricLoggerUnit["Megabytes"] = "Megabytes";
  MetricLoggerUnit["Gigabytes"] = "Gigabytes";
  MetricLoggerUnit["Terabytes"] = "Terabytes";
  MetricLoggerUnit["Bits"] = "Bits";
  MetricLoggerUnit["Kilobits"] = "Kilobits";
  MetricLoggerUnit["Megabits"] = "Megabits";
  MetricLoggerUnit["Gigabits"] = "Gigabits";
  MetricLoggerUnit["Terabits"] = "Terabits";
  MetricLoggerUnit["Percent"] = "Percent";
  MetricLoggerUnit["Count"] = "Count";
  MetricLoggerUnit["BytesPerSecond"] = "Bytes/Second";
  MetricLoggerUnit["KilobytesPerSecond"] = "Kilobytes/Second";
  MetricLoggerUnit["MegabytesPerSecond"] = "Megabytes/Second";
  MetricLoggerUnit["GigabytesPerSecond"] = "Gigabytes/Second";
  MetricLoggerUnit["TerabytesPerSecond"] = "Terabytes/Second";
  MetricLoggerUnit["BitsPerSecond"] = "Bits/Second";
  MetricLoggerUnit["KilobitsPerSecond"] = "Kilobits/Second";
  MetricLoggerUnit["MegabitsPerSecond"] = "Megabits/Second";
  MetricLoggerUnit["GigabitsPerSecond"] = "Gigabits/Second";
  MetricLoggerUnit["TerabitsPerSecond"] = "Terabits/Second";
  MetricLoggerUnit["CountPerSecond"] = "Count/Second";
  MetricLoggerUnit["None"] = "None";
})(MetricLoggerUnit || (MetricLoggerUnit = {}));

export var IMetric = /*#__PURE__*/_createClass(function IMetric() {
  _classCallCheck(this, IMetric);
});
export var MetricLogger = /*#__PURE__*/function (_IMetric) {
  _inherits(MetricLogger, _IMetric);

  var _super = _createSuper(MetricLogger);

  function MetricLogger() {
    _classCallCheck(this, MetricLogger);

    return _super.call(this);
  }

  _createClass(MetricLogger, [{
    key: "putDimensions",
    value: function putDimensions(dimensions) {
      setGlobalLogger(log.child(dimensions));
    }
  }, {
    key: "putMetric",
    value: function putMetric(key, value, unit) {
      log.info({
        key: key,
        value: value,
        unit: unit
      }, "[Metric]: ".concat(key, ": ").concat(value, " | ").concat(unit ? unit : ''));
    }
  }]);

  return MetricLogger;
}(IMetric);
export var metric = new MetricLogger();
export var setGlobalMetric = function setGlobalMetric(_metric) {
  metric = _metric;
};